import * as Yup from "yup";

export function initialValues() {
  return {
    paymentCategoryId: "",
    paymentConceptId: "",
  };
}

export function validationSchema() {
  return Yup.object({
      paymentCategoryId: Yup.string().required("La categoría de pago es obligatoria"),
      paymentConceptId: Yup.string().required("El concepto de pago es obligatorio").nullable(),
  });
}
